<template>
    <div class="demo-inline-spacing">
        <Button
            v-if="isLifeCycleVisible"
            class="mt-0"
            :variant="lifeCycleButtonVariant"
            @click="showLifeCycle"
        >
            {{ $t('Component(Button):request-life-cycle') }}
        </Button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="forward"
            v-if="showForward && request.status === 'new'"
        >
            {{ $t('Component(Button):forward-to-supplier') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            :disabled="isReplyDisabled"
            @click="reply"
            v-if="showReply"
        >
            {{ $t('Component(Button):send-reply') }}
        </b-button>
        <b-button
            v-if="showSave"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="save"
        >
            {{ $t('Component(Button):save') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="close"
        >
            {{ $t('Component(Button):close') }}
        </b-button>
    </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Button from "@core/components/common/Button.vue";
export default {
    components: {
        Button,
        BButton
    },
    directives: {Ripple},
    props: {
        request: {
            required: true,
        },
        showSave: {
            default: false
        },
        showReply: {
            default: false
        },
        showForward: {
            default: true
        },
        isReplyDisabled: {
            default: false
        },
        isLifeCycleVisible: {
            default: true
        },
        lifeCycleButtonVariant: {
            default: 'primary'
        }
    },
    methods: {
        showLifeCycle() {
            this.$emit('showLifeCycle')
        },
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save');
        },
        reply() {
            this.$emit('reply');
        },
        forward() {
            this.$emit('forward')
        }
    }
}
</script>
